<template>
  <roe-error-message :field="design[attrName()]">
    <roe-percent-input
      v-model="design.$model[attrName()]"
      :disabled="disableVestingYears()"
      @change="changeVestingYears"
    ></roe-percent-input>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoePercentInput from "@/components/_shared/inputs/PercentInput";
export default {
  name: "RoeVestingPercentInput",
  components: { RoePercentInput, RoeErrorMessage },
  props: {
    design: Object,
    number: Number,
    type: {
      type: String,
      default() {
        return "other";
      }
    }
  },
  methods: {
    disableVestingYears() {
      return (
        this.number !== 1 &&
        +this.design.$model[this.attrName(this.number - 1)] === 1
      );
    },
    attrName(number = this.number) {
      let type = this.type === "match" ? "match" : "profit_sharing";
      return `percent_${type}_vesting_${number}_year`;
    },
    changeVestingYears() {
      if (this.number === 6 || +this.design.$model[this.attrName()] !== 1)
        return;
      [1, 2, 3, 4, 5, 6].forEach(n => {
        if (n > this.number) this.design.$model[this.attrName(n)] = 1;
      });
    }
  }
};
</script>
